module.exports = __webpack_public_path__ + "static/media/example_background.b0129b20.jpg";